import {inject, injectable} from 'inversify';

import type {ID} from '../../../utils/utility-types';

import {FetchFollowersListByUserIdQuery} from '../../../core/ports/Follower/FetchFollowersListByUserId/FetchFollowersListByUserId.query';
import {CurrentUserService} from '../../../core/system/currentUser/CurrentUser.service';
import {logger} from '../../../utils/logger';

@injectable()
export class CheckIsUserCoachClientUseCase {
  constructor(
    @inject(FetchFollowersListByUserIdQuery)
    private readonly query: FetchFollowersListByUserIdQuery,
    @inject(CurrentUserService)
    private readonly currentUser: CurrentUserService,
  ) {}

  async exec({id}: CheckIsUserCoachClientUseCase.Props): Promise<any> {
    try {
      if (!this.currentUser.user?.isCoach) {
        return false;
      }

      const followers = await this.query.exec({isForCoach: true, userId: id});

      if (followers.length === 0) {
        return false;
      }

      return true;
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace CheckIsUserCoachClientUseCase {
  export type Props = {
    id: ID;
  };
}
